import { Component, OnInit } from '@angular/core';
import { USER_MESSAGE_RETURN_URL_STORAGE_KEY, UserMessageData } from '../../domain/models/user-message.model';
import { UserMessageFacade } from '../../domain/+state/user-message.facade';
import { HasPendingMessages } from '../../infrastructure/user-messages-can-deactivate.guard';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Router } from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'ifc-user-messages-page',
  templateUrl: './user-messages-page.component.html',
  styleUrls: ['./user-messages-page.component.scss'],
  standalone: false
})
export class UserMessagesPageComponent implements OnInit, HasPendingMessages {
  messages: UserMessageData[];
  currentMessage: UserMessageData;
  private currentIndex: number;

  constructor(
    private readonly facade: UserMessageFacade,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.loadMessages();
  }

  private loadMessages(): void {
    this.facade.getNewPopupMessages()
      .subscribe((messages) => {
        this.messages = messages;

        if (messages.length === 0) {
          this.redirectToReturnUrl();
          return;
        }

        this.currentIndex = 0;
        this.currentMessage = this.messages[this.currentIndex];
      });
  }

  onMessageAcknowledged(): void {
    const lastMessage = this.currentMessage;
    if (this.currentMessage) {
      this.facade.markAsDisplayed(lastMessage);
      this.facade.dismissMessage(lastMessage).subscribe();
    }

    this.currentIndex++;
    const nextMessage = this.currentIndex < this.messages.length ? this.messages[this.currentIndex] : undefined;
    this.currentMessage = nextMessage;

    if (!nextMessage) {
      this.redirectToReturnUrl();
    }
  }

  hasPendingMessages(): boolean {
    return !!this.currentMessage;
  }

  private redirectToReturnUrl(): void {
    const returnUrl = this.getReturnUrl();
    if (returnUrl) {
      this.router.navigateByUrl(returnUrl, { replaceUrl: true });
      return;
    }

    this.router.navigate(['dashboard'], {
      replaceUrl: true,
      queryParamsHandling: 'preserve',
    });
  }

  private getReturnUrl(): string {
    const returnUrl = sessionStorage.getItem(USER_MESSAGE_RETURN_URL_STORAGE_KEY);

    if (!returnUrl || returnUrl.includes('/messages')) {
      sessionStorage.removeItem(USER_MESSAGE_RETURN_URL_STORAGE_KEY);
      return null;
    }

    sessionStorage.removeItem(USER_MESSAGE_RETURN_URL_STORAGE_KEY);
    return returnUrl;
  }

  trackByMessage = (index: number, message: UserMessageData): string => {
    return this.facade.getMessageFingerprint(message);
  }
}
